import styled from 'styled-components';
import { colors } from '../../styles/colors';

export const Container = styled.div`
  border: 1px solid ${colors.stroke['soft-200']};
  border-radius: 8px;
  background: ${colors.bg['white-0']};
  overflow: hidden;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 10px;
  gap: 12px;
  flex-wrap: wrap;
`;

export const HeaderLeft = styled.div``;

export const HeaderTitle = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: ${colors.text['main-900']};
`;

export const HeaderCounter = styled.div`
  font-size: 12px;
  color: ${colors.text['sub-500']};
  margin-top: 2px;
`;

export const HeaderCounterBold = styled.strong`
  color: ${colors.text['primary-base']};
  font-weight: 600;
`;

export const HeaderActions = styled.div`
  display: flex;
  gap: 4px;
`;

export const ActionButton = styled.button<{ dimmed?: boolean }>`
  background: transparent;
  border: 0;
  color: ${({ dimmed }) => (dimmed ? colors.text['sub-500'] : colors.text['primary-base'])};
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  font-family: inherit;
  white-space: nowrap;

  &:hover:not(:disabled) {
    background: ${colors.brand.primary.lighter};
  }

  &:disabled {
    color: ${colors.text['sub-300']};
    cursor: default;
  }
`;

export const SearchWrapper = styled.div`
  padding: 10px;
  border-bottom: 1px solid ${colors.stroke['soft-200']};
  background: ${colors.bg['white-0']};
`;

export const SearchInputWrapper = styled.div`
  position: relative;
`;

export const SearchInputIcon = styled.div`
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  display: flex;
  align-items: center;
`;

export const SearchInputBase = styled.input`
  width: 100%;
  height: 34px;
  padding: 0 32px 0 34px;
  border: 1px solid ${colors.stroke['soft-200']};
  border-radius: 6px;
  background: ${colors.bg['white-0']};
  font-size: 13px;
  font-family: inherit;
  color: ${colors.text['main-900']};
  outline: none;
  transition: border-color 120ms ease, box-shadow 120ms ease;

  &::placeholder {
    color: ${colors.text['sub-300']};
  }

  &:focus {
    border-color: #363BC4;
    box-shadow: 0 0 0 3px rgba(54, 59, 196, 0.2);
  }
`;

export const SearchInputClearBtn = styled.button`
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: 0;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ListWrapper = styled.div<{ height: number; maxHeight: number }>`
  height: ${({ height }) => height}px;
  max-height: ${({ maxHeight }) => maxHeight}px;
  overflow-y: auto;
  padding: 6px;
`;

export const Row = styled.label`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  cursor: pointer;
  border-radius: 6px;
  transition: background 100ms ease;

  &:hover {
    background: ${colors.bg['weak-100']};
  }
`;

export const RowLabel = styled.span`
  font-size: 12px;
  color: ${colors.text['main-900']};
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const PaginationFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 14px;
  border-top: 1px solid ${colors.stroke['soft-200']};
  background: ${colors.bg['weak-100']};
  flex-wrap: wrap;
  gap: 6px;
`;

export const PaginationRangeText = styled.span`
  font-size: 12px;
  color: ${colors.text['sub-500']};
  white-space: nowrap;
`;

export const PaginationNav = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const PaginationBtn = styled.button<{ $active?: boolean }>`
  min-width: 28px;
  height: 28px;
  padding: 0 8px;
  border: 1px solid ${({ $active }) => ($active ? colors.text['primary-base'] : colors.stroke['soft-200'])};
  background: ${({ $active }) => ($active ? colors.text['primary-base'] : colors.bg['white-0'])};
  color: ${({ $active }) => ($active ? '#fff' : colors.text['main-650'])};
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &:disabled {
    color: ${colors.text['sub-300']};
    border-color: ${colors.stroke['soft-200']};
    cursor: default;
  }
`;

export const PaginationEllipsis = styled.span`
  width: 22px;
  text-align: center;
  font-size: 12px;
  color: ${colors.text['sub-500']};
  align-self: center;
`;

export const EmptyStateWrapper = styled.div`
  padding: 28px 12px;
  text-align: center;
  color: ${colors.text['sub-500']};
  font-size: 13px;
`;

export const EmptyStateTitle = styled.div`
  font-weight: 500;
  color: ${colors.text['main-900']};
  margin-bottom: 4px;
`;

export const EmptyStateText = styled.div`
  font-size: 12px;
`;

export const ClearSearchButton = styled.button`
  background: transparent;
  border: 0;
  color: ${colors.text['primary-base']};
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  padding: 0;
  font-family: inherit;
`;
